import { render, staticRenderFns } from "./not-respond.vue?vue&type=template&id=6066c01a&scoped=true"
import script from "./not-respond.vue?vue&type=script&lang=js"
export * from "./not-respond.vue?vue&type=script&lang=js"
import style0 from "./not-respond.vue?vue&type=style&index=0&id=6066c01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066c01a",
  null
  
)

export default component.exports